import {
  Button,
  Card,
  CardActions,
  CardContent, CardHeader,
  Checkbox, CircularProgress,
  Collapse,
  Divider,
  FormControlLabel,
  List, ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import FormGroup from "@material-ui/core/FormGroup";
import InboxIcon from "@material-ui/icons/Edit";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import SaveIcon from '@material-ui/icons/Save';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    minHeight: 430,
    maxHeight: 600,
    overflow: 'auto'
  },
  fieldsComplementary: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policyComplementary: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckboxComplementary: {
    marginLeft: '-14px'
  },
  submitButtonComplementary: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  contentComplementary: {
    minHeight: 430,
  },
  dividerComplementary: {
    backgroundColor: '#FF9800'
  },
  submitButtonTamamlayiciSatis: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

function Benchmark({ className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [SelectedValue, setSelectedValue] = useState([]);
  const [benchmarkBrandProductData, setBenchmarkBrandProductData] = useState([]);
  const [benchmarkEntry, setBenchmarkEntry] = React.useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  let DataBenchmark = readonly ? (Array.isArray(tasks?.tasks) ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : []) : loadBaslandiJob();

  if (!readonly && (!DataBenchmark || DataBenchmark.length === 0)) {
      const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
      if (current) {
        saveBaslandiJob(current);
        DataBenchmark = loadBaslandiJob();
      }
    }
  


  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };


  const handleClick = (index) => {
    var SelectedValueCopy = [...SelectedValue];
    SelectedValueCopy[index].IsOpen = !SelectedValueCopy[index].IsOpen;
    setSelectedValue(SelectedValueCopy);
  };

  const GetArtemisBenchmarkEntry = useCallback(() => {
    let isMounted = true;
    const job = DataBenchmark[0];
    axios.get(`/GetArtemisBenchmarkEntry/${job.FisNo}`)
      .then(response => {
        if (isMounted && response.data.length > 0) {
          setBenchmarkEntry(response.data);
        }
      })
      .catch(error => {
        logger.error("Benchmark entry error:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [DataBenchmark]);

  useEffect(() => {
    let isMounted = true;

    const fetchBenchmarkBrand = () => {
      axios.get(`/GetArtemisBenchmarkBrand`)
        .then(response => {
          if (isMounted && response.data.length > 0) {
            var xd = [];
            for (var i = 0; i < response.data.length; i++) {
              xd.push({
                id: i,
                IsOpen: false
              })
            }
            setSelectedValue(xd);
          }
        })
        .catch(error => {
          logger.error("Benchmark brand error:", error.message);
        });
    };

    const fetchBenchmarkBrandProduct = () => {
      axios.get(`/GetArtemisBenchmarkBrandProduct`)
        .then(response => {
          if (isMounted && response.data.length > 0) {
            setBenchmarkBrandProductData(response.data);
          }
        })
        .catch(error => {
          logger.error("Benchmark brand product error:", error.message);
        });
    };

    fetchBenchmarkBrand();
    fetchBenchmarkBrandProduct();
    const cleanup = GetArtemisBenchmarkEntry();

    return () => {
      isMounted = false;
      if (cleanup) cleanup();
    };
  }, [GetArtemisBenchmarkEntry]);

  const handleSelectedProduct = (index) => {
    var filteredSelected = selectedProduct.filter(d => (d) === index)
    if (filteredSelected.length > 0) {
      selectedProduct.splice(filteredSelected, 1);
    } else {
      setSelectedProduct([...selectedProduct, index]);
    }
  }

  const handleSave = () => {
    if (selectedProduct.length === 0) {
      setUyari(true)
      setUyariTip("error")
      setUyariAciklama("Lütfen önce ürün grubu seçiniz!")
    } else {
      const job = DataBenchmark[0];

      const formattedProducts = selectedProduct.map(item => ({
        ...item,
        MODEL_ID: String(item.MODEL_ID) // Sayıyı string'e çevirir
      }));


      let productSelected = {
        FIS_NO: job.FisNo,
        "products": formattedProducts,
        TEKNISYEN_KODU: job.TEKNISYEN_KODU
      }

      let isMounted = true;

      axios.post('/SetArtemisBenchmarkProducts', productSelected)
        .then(res => {
          if (!isMounted) return;
          
          const response = res.data.length === 0 ? [] : res.data;
          if (response.ErrorCode === "0") {
            setUyariTip("success");
            setUyari(true);
            setLoadingControl(false);
            setUyariAciklama(response.ErrorDescription);
            GetArtemisBenchmarkEntry();
          }
          else {
            setUyariTip("error");
            setUyari(true);
            setUyariAciklama(response.ErrorDescription);
            setLoadingControl(false);
            return;
          }
        })
        .catch(error => {
          if (isMounted) {
            setUyariTip("error");
            setUyari(true);
            setUyariAciklama("Kayıt sırasında hata oluştu");
            setLoadingControl(false);
          }
          logger.error("Benchmark save error:", error.message);
        });

      return () => {
        isMounted = false;
      };
    }
  }

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        subheader="Müşteri evinde farklı marka ürün var mı, gözlemlediğiniz bir ürün varsa bu alanı doldurabilirsiniz." />
      <Divider />
      <CardActions>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={handleSave}
          disabled={benchmarkEntry?.length > 0 ? true : false}
          endIcon={<SaveIcon />}>
          {benchmarkEntry?.length > 0 ? "ANKET TAMAMLANDI"
            : "KAYDET"}
        </Button>
      </CardActions>
      <Divider />
      {
        uyari ?
          <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
          : <div></div>
      }
      {
        LoadingControl ?
          <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />
          :
          <CardContent className={classes.content}>
            {benchmarkBrandProductData?.map((index, i) => (
              <List
                key={index.MARKA_ID}
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
              >
                <ListItem
                  button onClick={() => { handleClick(i) }}>
                  <ListItemIcon>
                    <InboxIcon />
                  </ListItemIcon>
                  <ListItemText primary={index.MARKA_ADI} />
                  {SelectedValue[i]?.IsOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={SelectedValue[i]?.IsOpen}
                  timeout="auto" unmountOnExit>
                  {index?.P?.map((product, pIndex) => (
                    <List key={`${index.MARKA_ID}-${pIndex}`} component="div" disablePadding>
                      <ListItem
                        button className={classes.nested} onClick={() => { handleSelectedProduct(product) }} >
                        <FormGroup row>
                          <FormControlLabel control={<Checkbox name="checkedA" />} />
                        </FormGroup>
                        <ListItemText primary={product?.MODEL_ADI} />
                      </ListItem>
                    </List>
                  ))}
                </Collapse>
              </List>
            ))}
          </CardContent>
      }
    </Card >
  );
}

Benchmark.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({ tasks: state.tasks1 })
)(Benchmark);
